export default __webpack_public_path__ + "static/media/partner-9-mavia.7bfd64ac.png";